export enum ClientBrandCode {
  AEG = 'AEG',
  Amana = 'AMANA',
  Amica = 'AMIC',
  Argos = 'ARGO',
  Baumatic = 'BAUM',
  Baxi = 'baxi',
  Beko = 'BEKO',
  Belling = 'BELL',
  Blomberg = 'BLOM',
  Bosch = 'BOSC',
  Bush = 'BUSH',
  Candy = 'CAND',
  Cannon = 'CANN',
  Cda = 'CDA',
  Comfee = 'COMF',
  Creda = 'CRED',
  DomesticAndGeneral = 'DandG',
  Flavel = 'FLAV',
  Grundig = 'GRUN',
  Haier = 'HAIE',
  Hoover = 'HOOV',
  Hotpoint = 'HOTP',
  Indesit = 'INDE',
  JennAir = 'JNAIR',
  KitchenAid = 'KHAID',
  LEC = 'LEC',
  Leisure = 'LEIS',
  LG = 'LG',
  Matrix = 'MATR',
  Maytag = 'MAYT',
  MaytagUS = 'MYTAG',
  Miele = 'MIEL',
  MiraShowers = 'MIRA',
  Stoves = 'STOV',
  Vaillant = 'VAIL',
  Whirlpool = 'WHIR',
  Zenith = 'ZENI',
}
